<pcp-slide-sync-toolbar-button
    [matIcon]="'reply'"
    [disabled]="disabled"
    (click)="onButtonClicked()"
></pcp-slide-sync-toolbar-button>
